export enum AlertType {
    Success,
    Warning,
    Error,
    Notification
}
